import MessageThreadHeaderListItem from './MessageThreadHeaderListItem';

export default MessageThreadHeaderListItem;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadHeaderListItem/index.js